export default __webpack_public_path__ + "static/media/1071.d8055e74.png";